"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleMaps = void 0;
var Common_1 = require("ContentTokens/Models/Common");
var Text_1 = require("./Text");
exports.googleMaps = {
    createToken: function (displayUrl, embedUrl, width) {
        if (displayUrl === void 0) { displayUrl = ""; }
        var token = {
            type: "block",
            subType: "googleMaps",
            displayUrl: displayUrl,
        };
        if (embedUrl != undefined) {
            token.embedUrl = embedUrl;
        }
        if (width != undefined) {
            token.width = width;
        }
        return token;
    },
    createSlateJson: function () {
        return {
            isVoid: true,
            type: Common_1.BlockType.GoogleMaps,
            children: [Text_1.text.createSlateJson()],
            data: {},
        };
    },
};
